<template>
  <div class="container feedback-container">
    <div class="feedback">
      <span class="feedback__title">Мы хотим сделать проект максимально полезным</span>
      <span class="feedback__subtitle">присылайте комментарии и рекомендации!</span>
      <input type="text" placeholder="Имя" class="feedback__input" v-model="name">
      <input type="text" placeholder="Email" class="feedback__input" v-model="email">
      <textarea placeholder="Введите сообщение" class="feedback__textarea" v-model="message"></textarea>
      <Error v-if="error" :text="error"/>
      <Success v-if="success" :text="success"/>
      <Button text="Отправить" color="green" @action="sendFeedback" :disabled="disabledSend"/>
    </div>
  </div>
</template>

<script>
  import Button from '@/components/Button.vue';
  import Error from '@/components/Error.vue';
  import Success from '@/components/Success.vue';

  export default {
    components: {
      Button,
      Error,
      Success
    },
    data() {
      return {
        name: '',
        email: '',
        message: '',
        error: '',
        success: ''
      }
    },
    methods: {
      async sendFeedback() {
        const email = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/.test(this.email);
        if (!email) {
          this.error = 'Неправильно введен email';
          setTimeout(() => {
            this.error = '';
          }, 2000);
        } else {
          await this.$store.dispatch('sendFeedback', {name: this.name, email: this.email, text: this.message, domain: 'epidemic'})
          this.success = 'Спасибо за обратную связь! Ваше сообщение отправлено';
          this.name = '';
          this.email = '',
          this.message = '';
          setTimeout(() => {
            this.success = '';
          }, 4000);
        }
      }
    },
    computed: {
      disabledSend() {
        return this.name.length < 3 || this.email.length < 5 || this.message.length < 5
      }
    }
  }
</script>

<style lang="scss" scoped>
.feedback {
  background: #fff;
  color: #000;
  box-shadow: 0 3px 6px rgba(6, 12, 16, 0.16);
  border-radius: 3px;
  padding: 20px;
  &__title {
    max-width: 560px;
    margin: 0 auto;
    font-size: 35px;
    text-align: center;
    display: block;
    font-weight: bold;
    margin-top: 5px;
  }
  &__subtitle {
    display: block;
    text-align: center;
    font-size: 17px;
    margin-bottom: 20px;
  }
  &__input {
    display: block;
    margin-bottom: 20px;
    border-radius: 5px;
    border: 1px solid #c2d5e1;
    height: 40px;
    padding: 0 12px;
    color: #000;
    width: 100%;
    font-size: 17px;
  }
  &__textarea {
    height: 145px;
    padding: 12px;
    border: 1px solid #c2d5e1;
    font-family: Foros, Arial, sans-serif;
    font-size: 17px;
    color: #000;
    width: 100%;
    border-radius: 5px;
    resize: none;
    margin-bottom: -10px;
  }
}

@media screen and (max-width: 767px) {  
  .feedback {
    padding-top: 50px;
    padding-bottom: 50px;
    margin-bottom: 50px;
    &-container {
      padding: 0;
    }
    &__title {
      font-size: 25px;
    }
  }
}
</style>